import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { type z } from 'zod';
import { SignUpWidget } from '@/module/auth/sign-up/components';
import { type NormalSchema } from '@/module/auth/sign-up/SignUpDetail/schema';
import { Checkbox } from '@/ui';
import { cn } from '@/utils';
export const TermsSection = () => {
  const {
    watch,
    setValue,
    getValues
  } = useFormContext<z.infer<typeof NormalSchema>>();
  const {
    t
  } = useTranslation(['common']);
  const marketingConsentChecked = watch('emailMarketingAgreement') || watch('phoneMarketingAgreement') ? true : false;
  const toggleMarketing = () => {
    const next = !marketingConsentChecked;
    setValue('emailMarketingAgreement', next);
    setValue('phoneMarketingAgreement', next);
  };
  return <SignUpWidget.Section className={'min-h-0 tablet-sm:gap-md'} data-sentry-element="unknown" data-sentry-component="TermsSection" data-sentry-source-file="TermsSection.tsx">
      <ul className={'flex flex-col gap-md'}>
        <CheckRow checked={marketingConsentChecked} onClickCheck={toggleMarketing} actionButton={getValues('userType') === 'student' ? null : <SubCheckbox />} text={<div className={'flex flex-col'}>
              <span>
                <span className={'text-assistive'}>
                  ({t('account.signup.select')})
                </span>
                &nbsp;
                {t('account.terms.marketingAgreement')}
              </span>
              <span className={'text-caption-lg-regular text-assistive'}>
                {t('account.terms.marketingBenefitsInfo')}
              </span>
            </div>} data-sentry-element="CheckRow" data-sentry-source-file="TermsSection.tsx" />
      </ul>
    </SignUpWidget.Section>;
};
export const SubCheckbox = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    watch,
    setValue
  } = useFormContext<z.infer<typeof NormalSchema>>();
  return <div className={'flex items-center gap-xs'} data-sentry-component="SubCheckbox" data-sentry-source-file="TermsSection.tsx">
      <CheckBoxLabel htmlFor={'emailMarketingAgreement'} data-sentry-element="CheckBoxLabel" data-sentry-source-file="TermsSection.tsx">
        <Checkbox id={'emailMarketingAgreement'} checked={watch('emailMarketingAgreement')} onCheckedChange={b => setValue('emailMarketingAgreement', Boolean(b), {
        shouldDirty: true
      })} data-sentry-element="Checkbox" data-sentry-source-file="TermsSection.tsx" />
        {t('account.signup.email')}
      </CheckBoxLabel>

      <CheckBoxLabel htmlFor={'phoneMarketingAgreement'} data-sentry-element="CheckBoxLabel" data-sentry-source-file="TermsSection.tsx">
        <Checkbox id={'phoneMarketingAgreement'} checked={watch('phoneMarketingAgreement')} onCheckedChange={b => setValue('phoneMarketingAgreement', Boolean(b), {
        shouldDirty: true
      })} data-sentry-element="Checkbox" data-sentry-source-file="TermsSection.tsx" />
        {t('account.signup.phone')}
      </CheckBoxLabel>
    </div>;
};
const CheckBoxLabel = (props: ComponentPropsWithoutRef<'label'>) => {
  return <label {...props} className={'flex shrink-0 cursor-pointer items-center gap-xs text-center text-body-md-semibold text-default'} data-sentry-component="CheckBoxLabel" data-sentry-source-file="TermsSection.tsx" />;
};
export const CheckRow = (props: {
  text: ReactNode;
  onClickCheck: () => void;
  checked: boolean;
  actionButton?: ReactNode;
  alignSelf?: boolean;
  forceWrap?: boolean;
}) => {
  return <li className={cn('flex min-h-[26px] flex-row flex-wrap gap-y-xs cursor-pointer justify-between px-md overflow-hidden', props.forceWrap ? 'flex-col gap-y-2xs' : '')} data-sentry-component="CheckRow" data-sentry-source-file="TermsSection.tsx">
      <div className={cn('flex gap-xs text-body-lg', props.forceWrap ? 'basis-full' : 'basis-[300px]', props.alignSelf && 'md:items-start')} onClick={props.onClickCheck}>
        <div className={'self-start tablet-sm:self-auto tablet-sm:pt-0'}>
          <Checkbox checked={props.checked} data-sentry-element="Checkbox" data-sentry-source-file="TermsSection.tsx" />
        </div>
        <div className={'block pt-[1px] text-body-md font-semibold text-default'}>
          {props.text}
        </div>
      </div>
      <div className={cn(props.forceWrap && 'w-full pl-xl')}>
        {props.actionButton}
      </div>
    </li>;
};